import React from 'react';
import { Toast } from 'components/lib/toast';

const LoadingPage = () => (
  <Toast className="radius-xxs shadow-xs margin-xl">Loading...</Toast>
);

export default LoadingPage;
